import request from '@/utils/request'

// 获取北京CA注册状态信息
export const getCaRegisterInfo = () => {
    return request.get('/api/expert-database/ca-register-info')
}

//专家库信息
export const getExpertInfo = () => {
    return request.get('/api/expert-database/info')
}

//专家库注册
export const register = (data) => {
    return request.post('/api/expert-database/register', data)
}
//专家库重置登录密码
export const resetLoginPassword = (data) => {
    return request.post('/api/expert-database/reset-login-password', data)
}
/**
 * 专家相关接口
 */
//专家库发送短信验证码
export const sendSmsCode = (data) => {
    return request.post('/api/expert-database/send-sms-code', data)
}
//专家库登录
export const login = (data) => {
    return request.post('/api/expert-database/login', data)
}

//专家库更新印章密码
export const updateSealPassword = () => {
    return request.get('/api/expert-database/update-seal-password')
}
